export enum SourceType {
    sale = 'SALE',
    subscription = 'SUBSCRIPTION',
    refund = 'REFUND'
}